import { sortVersionsComparator } from '@/helpers';

export default function (state) {
  if (!state.loggedInSpeakerId) {
    return [];
  }

  return Object.values(state.versions).sort(sortVersionsComparator);
}
